<script>

import { mapActions, mapGetters, mapMutations } from "vuex";
import {swal} from '../../../helpers/handle_error';
import AlertError from '@/components/alert_error'
import Loader from '@/components/widgets/loader'

export default {
  components: { AlertError, Loader },
  data() {
    return {
      //Page errors.
      errors: [],
      showLoader:true,
      showLoaderDownload: 0,

      // datatable
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50 ,100,{value: Number.MAX_SAFE_INTEGER,text: "عرض الكل"}],
      filter: null,
      filterOn: [],
      sortBy: "created_at",
      sortDesc: true,
      fields: [
        {
          // A virtual column that doesn't exist in items
          label: 'التسلسل',
          key: "index",
          sortable: true,
          visible: true
        },
        {
          label: 'العنوان',
          key: "Title",
          sortable: true,
          visible: true
        },
        {
          label: 'تاريخ الانشاء',
          key: "created_at",
          sortable: true,
          visible: true
        },
        {
          label: 'الاجراءات',
          key: "settings",
          sortable: false,
          class: "col-setting-doc",
          visible: this.$store.getters['auth/getUser'].hasAnyPermission(['edit_blog', 'delete_blog'])
        },
      ],
    };
  },
  computed: {
    ...mapGetters('blog', ['getBlogs']),
    rows() {
      return this.getBlogs.length;
    },
  },
  methods: {
    visibleFields() {
      return this.fields.filter(field => field.visible)
    },
    handleError(error){
      alert(error)
      if(error.response.status == 422) this.errors = Object.values(error.response.data.errors)
      else this.errors = [`Error Code : ${error.response.status}  Message : ${error.response.data.message}`]
    },
    ...mapMutations('blog', ['setBlogs']),
    ...mapActions("blog", ['getAll', 'delete']),
    // datatable
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    fetchAll(){
      this.getAll({
        all:1,
        order: 'desc'
      }).then(()=>this.showLoader = false)
      .catch((error)=>{
        this.handleError(error)
        this.showLoader = false
      })
    },
    async deleteItem(id) {
      if(await swal.confirm()){
        this.delete(id)
        .then((response)=>{
        swal.success(response.data.message)
        })
        .catch(this.handleError)
      }
    },
  },
  created(){
    this.setBlogs=[]
    this.fetchAll()
  }
};

</script>

<template>

  <div>
    <Loader :loading="showLoader" >

      <div class="row mt-3">
        <div class="col-12">

          <AlertError :errors="errors"></AlertError>

          <!-- Header Table -->
          <div class="row mt-1">
              <!-- table_length -->
              <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                          عرض&nbsp;:&nbsp;
                          <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm" :options="pageOptions"></b-form-select>
                          &nbsp;مدخلات
                      </label>
                  </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                      <label class="d-inline-flex align-items-center">
                          بحث&nbsp;:&nbsp;
                          <b-form-input v-model="filter" type="search" placeholder="بحث..." class="form-control form-control-sm ms-2"></b-form-input>
                      </label>
                  </div>
              </div>
          </div>

          <!-- Table -->
          <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  hover 
                  :items="getBlogs" 
                  :fields="visibleFields()" 
                  responsive="md" 
                  :per-page="perPage" 
                  :current-page="currentPage" 
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc" 
                  :filter="filter" 
                  :filter-included-fields="filterOn" 
                  @filtered="onFiltered">
                
                  <!-- A virtual column -->
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>

                  <!-- A custom formatted column Sutting -->
                  <template v-slot:cell(settings)="data">
                    <div class="button-items">                      
                      <router-link v-can="'edit_blog'" :to="{ name: 'offer.edit', params: { id: data.item.id } }">
                        <b-button class="btn-sm" variant="warning">تعديل</b-button>
                      </router-link>
                      <b-button v-can="'delete_blog'" class="btn-sm" variant="danger" title="حذف" @click="deleteItem(data.item.id)"><i class="bx bx-trash"></i></b-button>
                    </div>
                  </template>
              </b-table>
          </div>

          <!-- Footer Table -->
          <div class="row">
              <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                      <ul class="pagination pagination-rounded mb-0">
                          <!-- pagination -->
                          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                      </ul>
                  </div>
              </div>
          </div>   
        </div>
      </div>
    
    </Loader>

  </div>  

</template>